import BasePage from './base-page';

class Wishlist extends BasePage {

    onReady() {
        // init wishlist icons in product cards
        salla.storage.get('salla::wishlist', []).forEach(id => this.toggleFavoriteIcon(id));
    }

    registerEvents() {
        salla.wishlist.event.onAdded((event, id) => this.toggleFavoriteIcon(id));
        salla.wishlist.event.onRemoved((response, id) => {
            this.toggleFavoriteIcon(id, false);
            const item = document.querySelector('#wishlist-product-' + id);
            if (item) item.remove()
            if (!document.querySelector('#wishlist>*')) {
                window.location.reload();
            }
        });
    }


    toggleFavoriteIcon(id, isAdded = true) {
        document.querySelectorAll('.btn--wishlist[data-id="' + id + '"]')
            .forEach(btn => {
                app.toggleElementClassIf(btn, 'is-added', 'not-added', () => isAdded);
                // app.toggleElementClassIf(btn, 'pulse', 'un-favorited', () => isAdded);
            });
    }
}

Wishlist.initiateWhenReady();
